import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';

type ShareEncumbranceViewTableHeaderProps = {
  isReadOnly?: boolean;
};

const ShareEncumbranceViewTableHeader: FC<
  ShareEncumbranceViewTableHeaderProps
> = ({ isReadOnly }) => {
  const { t } = useTranslate();

  return (
    <>
      <thead className="table-light">
        <tr>
          <th className="text-left">{t('Name')}</th>
          <th className="text-center">{t('Date')}</th>
          <th className="text-center">{t('EndDate')}</th>
          <th className="text-center">{t('Shares')}</th>
          <th className="text-center">{t('From')}</th>
          <th className="text-center">{t('To')}</th>
          <th className="text-center">{t('Status')}</th>
          <th className="text-center">{t('CoOwners')}</th>
          {!isReadOnly && <th className="text-center" />}
        </tr>
      </thead>
    </>
  );
};

export default ShareEncumbranceViewTableHeader;
